// UserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    name: localStorage.getItem('name'),
    designation: localStorage.getItem('designation'),
  });

  // A function to update the user state, potentially after login or logout
  const updateUser = () => {
    setUser({
      name: localStorage.getItem('name'),
      designation: localStorage.getItem('designation'),
    });
  };

  // Listen for custom event signaling local storage changes
  useEffect(() => {
    const handleStorageChange = () => {
      updateUser();
    };

    window.addEventListener('storageChanged', handleStorageChange);

    return () => {
      window.removeEventListener('storageChanged', handleStorageChange);
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
